import { render, staticRenderFns } from "./ClientEntry.vue?vue&type=template&id=58a81a30&scoped=true"
import script from "./ClientEntry.vue?vue&type=script&lang=js"
export * from "./ClientEntry.vue?vue&type=script&lang=js"
import style0 from "./ClientEntry.vue?vue&type=style&index=0&id=58a81a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a81a30",
  null
  
)

export default component.exports